import React from 'react'
import intl from 'react-intl-universal'
import http from 'axios'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Header from './Header'
import Footer from './Footer'
import { isDark, getOdooUrl, getCompanyLogoUrl } from '../utils/Tools'
import { normalizeLang, locales } from '../utils/LangUtils'


require('bootstrap/dist/css/bootstrap.min.css')
require('../styles/App.scss')
require('../styles/hc.scss')

const mapStateToProps = state => ({
  authenticated: !!(state.auth && state.auth.session && state.auth.session.id),
  lang: state.auth.lang,
  hide_logo_on_start: state.config.hide_logo_on_start !== true,
  isOrderView: !!(state.auth && state.auth.session && state.auth.session.token && state.rma.order && !state.rma.done)
})

class AppComponent extends React.Component {

  constructor() {
    super()
    this.state = {
      initDone: false
    }
    if(document.querySelector('.logoStyle') === null){
      let logo = document.createElement('style')
      logo.classList.add('logoStyle')
      logo.innerHTML +=`
        #root header .logo{
          background-image: url(${getCompanyLogoUrl()})
        }
        `
      document.getElementsByTagName('head')[0].appendChild(logo)
    }
    if(document.querySelector('.brandStyle') === null){
      const odooUrl = getOdooUrl()
      const isCrossOrigin = (() => {
        try {
          return new URL(odooUrl).origin !== window.location.origin
        } catch (e) {
          return false
        }
      })()
      const isLocalDev = ['localhost', '127.0.0.1'].includes(window.location.hostname)
      if (!(isLocalDev && isCrossOrigin)) {
        http.get(`${odooUrl}/brand`).then((response) => {
          if(response.status === 200){
            let kolor = response.data
            let style = document.createElement('style')
            style.classList.add('brandStyle')
            let kolor_text = '#000'
            if(isDark(kolor)){
              kolor_text = '#fff'
            }
            if (kolor){
              style.innerHTML = `
                thead tr,
                #root main button:not(.react-datepicker__navigation):not(.filepond--file-action-button),
                #root main .button,
                #root main input[type="submit"],
                #popupContainer .mm-popup button,
                #root footer,
                #root thead tr,
                #popupContainer .mm-popup__box__header,
                #root footer a, #root footer a:hover, #root footer a:active, #root footer a:visited
                {
                  background-color: ${kolor};
                  color: ${kolor_text};
                }
                #root footer select.lang
                {
                  color: ${kolor_text};
                }
                #root footer svg{
                  fill: ${kolor_text} !important;
                }
                #root main .elem-list .elem-tile:hover{
                  border-color: ${kolor};
                }`
            }
            document.getElementsByTagName('head')[0].appendChild(style)
          }
        }).catch(() => {
          // no brand data - do nothing
        })
      }
    }
    let spinner = document.querySelector('.loaderWrap')
    if (spinner) spinner.style.display = 'none'
  }

  componentDidMount(){
    this.loadLocales()
  }

  componentDidUpdate(prevProps) {
    if (this.props.lang !== prevProps.lang) {
      this.loadLocales()
    }
  }

  fetchHeader(lang) {
    const odooUrl = getOdooUrl()
    http.get(`${odooUrl}/get_header/`, { params: { lang } }).then((response) => {
      if (response.status === 200) {
        localStorage.setItem('header', response.data)
      }
    }).catch(() => {
      localStorage.setItem('header', '')
    })
  }

  loadLocales() {
    let { lang } = this.props
    lang = normalizeLang(lang)

    let currentLocale = lang || intl.determineLocale({
      localStorageLocaleKey: 'lang'
    })

    if (!locales.find(l => l.value === currentLocale)) {
      currentLocale = 'pl-PL'
    }

    this.fetchHeader(currentLocale)

    http.get(`translations/${currentLocale}.json`).then(res => {
      // init method will load CLDR locale data according to currentLocale
      return intl.init({
        currentLocale,
        locales: { [currentLocale]: res.data }
      })
    }).then(() => {
      this.setState({
        initDone: true,
        currentLocale: currentLocale
      })
  
    })
  }

  render() {
    const {authenticated, children, hide_logo_on_start, isOrderView} = this.props
    const { initDone, currentLocale } = this.state
    const hideLogoOnStart = hide_logo_on_start
    const showLogo = !hideLogoOnStart || isOrderView
    return (
      initDone &&
      <article key={currentLocale} className={currentLocale}>
        <Header authenticated={authenticated} showLogo={showLogo}/>
        <main>
          {children}
        </main>
        <Footer locales={locales}/>
      </article>
    )
  }
}
const App = connect(mapStateToProps)(AppComponent)

export default withRouter(App)
